/**
 * Identifies the Till route a Till state was set up for: the route mode (none
 * for a new order) plus its order or location id.
 */
export const getTillHydrationKey = (mode: string | undefined, id: string) =>
	`${mode ?? "NEW_ORDER"}:${id}`;
